import React from 'react';

import BaseLayoutPromo from 'apps/promo/components/common/BaseLayoutPromo';
import { PromoInfoPage } from 'apps/promo/components/common/PromoInfoPage/PromoInfoPage';
import LibreNoAuthInfo from 'apps/promo/components/info/LibreNoAuthInfo';
import { LANDING_LINK } from 'apps/promo/constants/UrlConstants';
import { resolveArguments } from 'apps/promo/helpers/utils';
import { useExtra } from 'apps/promo/hooks/selectors';

const LibreNoAuthChequePage = (props) => {
    const { strapiApi } = useExtra();

    if (strapiApi?.paymentInfo) {
        return <LibreNoAuthInfo renderOptions={props.renderOptions} paymentInfo={strapiApi.paymentInfo} />;
    } else
        return (
            <BaseLayoutPromo>
                <PromoInfoPage
                    animatedIconFail
                    mainText={resolveArguments(strapiApi?.errorPageText, strapiApi?.alias)}
                    primaryButtonCaption={strapiApi?.errorPageButtonCaption}
                    primaryButtonType="link"
                    primaryButtonLink={LANDING_LINK}
                />
            </BaseLayoutPromo>
        );
};

export default LibreNoAuthChequePage;
